import "./message.css"
import Team from "../team/team"
function Message(){
    return(
        <>
        <div className="message">
            <div className="continer">
   <h3>Our Vision & Mission</h3>
<div className="content">
    <div className="row">
        <div className="col-md-4">
            <div className="box">
    <i className="fas fa-bullseye"></i>
    <h3>Mission</h3>
    <p>
        The mission of our medical center is to provide comprehensive and distinguished healthcare, placing the patient’s health and comfort at the forefront of our priorities. We aim to create a safe and supportive medical environment by using the latest technologies and best practices, while maintaining .
    </p>
</div>

        </div>
        
        <div className="col-md-4">
<div className="box">
    <i className="fas fa-hand-holding-heart"></i>
    <h3>Values</h3>
 <p>
    The long-term goal of our medical center is to become a leader in providing integrated and innovative healthcare, by continuously expanding our services and updating our medical technologies. We strive to be the first destination for patients seeking high-quality healthcare, with a strong focus on prevention and effective .
</p>
</div>

        </div>
       <div className="col-md-4">
    <div className="box">
        <i className="fas fa-eye"></i>
        <h3>Vision</h3>
        <p>
            We aspire to be the most trusted and preferred destination for integrated and innovative healthcare in the region. By adopting the latest medical technologies and creating a truly patient-centered environment, we aim to achieve sustainable health and comprehensive well-being for every individual in our community.
        </p>
    </div>
</div>

<div className="col-md-4">
    <div className="box">
        <i className="fas fa-user-md"></i>
        <h3>Our Team</h3>
        <p>
            Our center is proud to have a distinguished medical team of highly experienced consultants, specialists, nurses, and support staff across various fields. We are committed to continuous professional development through ongoing training and medical education to ensure the highest standards .
        </p>
    </div>
</div>

<div className="col-md-4">
    <div className="box">
        <i className="fas fa-shield-alt"></i>
        <h3>Quality & Safety</h3>
        <p>
            Quality and patient safety are the foundation of everything we do. We adhere to the highest international accreditation standards and continuously monitor performance through robust quality control, risk management, and patient safety programs to ensure a safe environment and reliable clinical outcomes.
        </p>
    </div>
</div>

<div className="col-md-4">
    <div className="box">
        <i className="fas fa-heartbeat"></i>
        <h3>Patient Care</h3>
        <p>
            The patient is at the heart of every decision we make. We are dedicated to delivering compassionate, personalized care — listening carefully to patients and their families, and providing a respectful, comfortable experience from the moment of arrival through treatment and follow-up.
        </p>
    </div>
</div>

<div className="col-md-4">
    <div className="box">
        <i className="fas fa-handshake"></i>
        <h3>Community Commitment</h3>
        <p>
            As an integral part of the community, we are committed to supporting public health through awareness campaigns, free or subsidized periodic screenings, educational programs, and preventive initiatives aimed at raising health literacy and reducing preventable diseases.
        </p>
    </div>
</div>

<div className="col-md-4">
    <div className="box">
        <i className="fas fa-star"></i>
        <h3>Excellence</h3>
        <p>
            We constantly strive for excellence in every aspect — from clinical quality and service speed to patient satisfaction. Through innovation, continuous improvement, and a culture of excellence, we aim to remain at the forefront of healthcare delivery in the region.
        </p>
    </div>
</div>
        
    </div>

</div>

            </div>
            <Team/>
        </div>
        </>
    )
}
export default Message